import { EFeatureCode } from '~/models/auth'
import { store } from '~/store'

function useHasVoipOrgFeature() {
  return store((state) =>
    state.organization.featureCodes.includes(EFeatureCode.voip),
  )
}

export default useHasVoipOrgFeature
